<template>
  <div class="e-cert">
    <div class="e-cert-certificates">
      <ul class="certificates" v-if="list && list.length">
        <li @click="dialogVisible = true; current = item" class="certificate" v-for="(item, index) in list" :key="index">
          <certificate
            class="certificate-img"
            width="100%"
            :name="item.truename"
            :content="getCertificateContent(item)"
            :time="item.certitime | fixDate"
            :code="item.certifnum"
            :item="item"
            :type="item.type === 1 ? 'online' : 'outline'"
            :teachers="item.teachers"
            @updateSrc="updateSrc"
          />
          <div class="certificate-content">
            <p class="title">{{ item.classtitle }}</p>
            <p class="desc">
              <span>证书编号：{{ item.certifnum }}</span>
              <span>发证日期：{{ item.certitime | fixDate }}</span>
            </p>
          </div>
        </li>
      </ul>
      <p class="e-cert-none" v-else-if="list === null">暂时没有证书～</p>
    </div>
    <el-dialog
      custom-class=""
      width="95%"
      center
      :visible.sync="dialogVisible"
      modal-append-to-body>
      <img v-if="current" :src="current.src" alt="" width="100%">
      <a v-if="current" class="certificate-download" href="javascript:void(0)" @click="$message.success('请长按图片保存')">保存到电脑</a>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api/index'
import Certificate from '@/components/certificate'

export default {
  data () {
    return {
      dialogVisible: false,
      current: null,
      list: undefined
    }
  },
  components: {
    Certificate
  },
  filters: {
    fixDate (timestamp) {
      return new Date(timestamp * 1000).toISOString().split('T')[0].replace('-','年').replace('-', '月') + '日'
    }
  },
  methods: {
    async getMyCerts () {
      let resp = await api.getMyCerts()
      this.list = resp.data.mycert
    },
    getCertificateContent (item) {
      const startTime = this.$options.filters.fixDate(item.fromtime)
      const endTime = this.$options.filters.fixDate(item.endtime).replace(startTime.slice(0, 5), '')
      const type = item.type === 1 ? '学院' : '线下培训'
      return `于${startTime}至${endTime}参加“${item.classtitle}”${type}课程，经考核成绩${item.rank}，特发此证。`
    },
    updateSrc (item, src) {
      item.src = src
    },
  },
  mounted () {
    this.getMyCerts()
  }
}
</script>

<style lang="scss" scoped>
.e-cert{
  .e-cert-certificates{
    .certificates{
      padding: 20px;
      width: 100%;
      box-sizing: border-box;
      .certificate{
        padding: 20px 0;
        display: flex;
        border-bottom: 1px solid #EBEBEB;
        &:nth-last-child(1){
          border-bottom: none;
        }
        .certificate-img{
          height: 112px;
          width: 160px;
        }
        .certificate-content{
          margin-left: 15px;
          .title{
            font-size: 15px;
            line-height: 22px;
            height: 44px;
            margin-bottom: 13px;
            color: #5C5F63;
            font-weight: 700;
          }
          .desc{
            span{
              margin-bottom: 7px;
              color: #7A7A7A;
              font-size: 12px;
              line-height: 16px;
              display: block;
            }
          }
        }
      }
    }
    .e-cert-none{
      width: 100%;
      text-align: center;
      margin-top: 45%;
      color: #909399;
    }
  }
  /deep/ .el-dialog{
    .el-dialog__header{
      padding: 0;
      .el-dialog__headerbtn{
        top: 100%;
        transform: translate(50%, 120px);
        right: 50%;
        font-size: 24px;
        display: block;
        border: 1px solid #fff;
        padding: 4px 5.5px;
        border-radius: 50%;
        font-weight: 700;
        .el-icon-close{
          color: #fff;
        }
      }
    }
    .el-dialog__body{
      padding: 3px;
      img{
        vertical-align: top;
      }
    }
    .certificate-download{
      position: absolute;
      bottom: -82px;
      left: 50%;
      transform: translateX(-50%);
      width: 128px;
      height: 38px;
      outline: none;
      box-shadow: none;
      border: none;
      background-color: #FF6565;
      font-size: 12px;
      border-radius: 3px;
      text-align: center;
      line-height: 38px;
      color: white;
      text-decoration: none;
    }
  }
}
</style>
